import React from 'react';
import OvalSpinner from '../Spinners/OvalSpinner';

// Unified pill-style button used for Start and Try Again
// Props: { onClick, disabled, pending=false, pendingText='Starting…', children }
const StartPillButton = ({ onClick, disabled=false, pending=false, pendingText='Starting…', children }) => {
  return (
    <button
      type="button"
      style={{
        border: '1px solid #5fbec5',
        color: '#5fbec5',
        background: 'transparent',
        borderRadius: '1.25rem',
        padding: '0.25rem 0.75rem',
        fontSize: '.8rem',
        cursor: disabled || pending ? 'wait' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8
      }}
      onClick={!disabled && !pending ? onClick : undefined}
      disabled={disabled || pending}
    >
      {pending ? (<><OvalSpinner size={14} color="#5fbec5" /> {pendingText}</>) : children}
    </button>
  );
};

export default StartPillButton;
